import { BcAntenatalRadioTextboxField } from "../BcAntenatalRadioTextboxField";

class BritishColumbiaObstetricalFileOtherSubstanceUse {
    public Other: BcAntenatalRadioTextboxField;
    public HasOtherDuringPregnancy?: boolean = null;
    public HasCocaine?: boolean = null;
    public HasOpioids?: boolean = null;
    public HasMethamphetamines?: boolean = null;
    public HasIntravenousDrugs?: boolean = null;
    public HasPrescriptionDrugs?: boolean = null;

    public constructor(fields?: Partial<BritishColumbiaObstetricalFileOtherSubstanceUse>) {
        Object.assign(this, fields);

        this.Other = new BcAntenatalRadioTextboxField(fields?.Other);
    }

    public hasSelectedAnyOtherSubstanceUse(): boolean {
        return this.HasOtherDuringPregnancy
            || this.HasCocaine
            || this.HasOpioids
            || this.HasMethamphetamines
            || this.HasIntravenousDrugs
            || this.HasPrescriptionDrugs
            || !!this.Other.Description;
    }
}

export { BritishColumbiaObstetricalFileOtherSubstanceUse };
